import React, {Component} from 'react';
import {DayPicker} from "react-day-picker";
import moment from "moment";
import {BudgetConfiguration} from "../accounts/BudgetConfiguration";
import {GoalConfiguration} from "./GoalConfiguration";
import {ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS, ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS} from "../BudgetTypes";
import {BU_PERIOD_PERIODIC, getBuPeriodName} from "../../../periods";
import ScheduleConfiguration from "../../elements/ScheduleConfiguration";
import { withTranslation } from 'react-i18next';

class BusinessUnitMainInfoClass extends Component {
    static dateFormat = 'DD/MM/YYYY';

    constructor(props) {
        super(props);

        this.state = {
            isDatePickerOpen: false,
            periodFirstDate: this.props.periodFirstDate,
            periodLastDate: this.props.periodLastDate
        };

        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleBudgetChange = this.handleBudgetChange.bind(this);
        this.handleGoal1Change = this.handleGoal1Change.bind(this);
        this.handleGoal2Change = this.handleGoal2Change.bind(this);
        this.handleScheduleConfigurationChange = this.handleScheduleConfigurationChange.bind(this);
        this.handleSelectedTemporalRangeDefinition = this.handleSelectedTemporalRangeDefinition.bind(this);
    }

    renderPeriodDates() {
        const { t } = this.props;
        if (this.props.periodType === BU_PERIOD_PERIODIC) {
            // Este feature se escondió porque no se viene usando
            if(this.props.firstDay === 1)
                return null;
            return (
                <div className="form-col">
                    <label>{t('business_unit_main_info.period_start_day')}</label>
                    <input name="first-day" type="text" value={this.props.firstDay} readOnly="readonly"
                           className="form-control"/>
                </div>
            )
        } else {
            const fromDate = this.state.periodFirstDate ? moment(this.state.periodFirstDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '';
            const toDate = this.state.periodLastDate ? moment(this.state.periodLastDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '';

            return (
                <div className="form-col">
                    <label>{t('business_unit_main_info.dates')}</label>
                    <div className="date-picker-container">
                        <input
                            type="text"
                            readOnly
                            className="form-control text-center white-background form-select"
                            value={`${fromDate}    →    ${toDate}`}
                            onClick={this.toggleDatePicker}
                        />
                        {this.state.isDatePickerOpen && (
                            <div className="date-picker-popover">
                                <DayPicker
                                    mode="range"
                                    numberOfMonths={2}
                                    selected={{
                                        from: this.state.periodFirstDate ? moment(this.state.periodFirstDate, 'YYYY-MM-DD').toDate() : undefined,
                                        to: this.state.periodLastDate ? moment(this.state.periodLastDate, 'YYYY-MM-DD').toDate() : undefined
                                    }}
                                    onSelect={this.handleSelectedTemporalRangeDefinition}
                                    disabled={this.dayIsInvalid}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )
        }
    }

    toggleDatePicker = () => {
        this.setState(prevState => ({ isDatePickerOpen: !prevState.isDatePickerOpen }));
    };

    dayIsInvalid = (aDay) => {
        // Calculate the minimum allowed date (3 months ago from today)
        const minDate = new Date();
        minDate.setMonth(minDate.getMonth() - 3);
        return minDate > aDay;
    };

    render() {
        return (
            <div className="business-unit-general-layout">
                <section className="business-unit-general-card business-unit-main-settings-card">
                    <header className="business-unit-general-card-header">
                        <h2>{this.props.t('business_unit_main_info.basic_configuration')}</h2>
                    </header>
                    <div className="business-unit-main-fields">
                        <div className="form-row business-unit-main-name-field">
                            <label>{this.props.t('business_unit_main_info.name')}</label>
                            <div className="business-unit-name-period-row">
                                <input name="name" type="text" onChange={this.props.onNameChange} value={this.props.name} className="form-control"/>
                                {this.renderPeriodSummary()}
                            </div>
                        </div>
                        <div className="business-unit-main-budget-field">
                            {this.renderBudgetSection()}
                        </div>
                    </div>
                    <div className="business-unit-schedule-section">
                        <ScheduleConfiguration onChange={this.handleScheduleConfigurationChange} itemScheduleConfiguration={this.props.itemScheduleConfiguration} />
                    </div>
                </section>
                <section className="business-unit-general-card business-unit-goals-card">
                    {this.renderGoalsSection()}
                </section>
            </div>
        );
    }

    renderGoalsSection() {
        const { t } = this.props;
        return (
            <div className="business-unit-goals-section">
                <header className="business-unit-goals-header">
                    <h2>{t('business_unit_main_info.control_line_goals')}</h2>
                </header>
                <GoalConfiguration priority={1}
                                   adAccountsActionData={this.props.adAccountsActionData}
                                   data={this.props.goal1}
                                   onChange={this.handleGoal1Change}/>

                <GoalConfiguration priority={2}
                                   adAccountsActionData={this.props.adAccountsActionData}
                                   data={this.props.goal2}
                                   onChange={this.handleGoal2Change}/>
            </div>
        );
    }

    renderPeriodSummary() {
        const { t } = this.props;
        const dateSummary = this.renderPeriodDateSummary();
        return (
            <div className="business-unit-period-summary">
                <span>{t('business_unit_main_info.period')}</span>
                <strong>{getBuPeriodName(this.props.periodType, t)}</strong>
                {dateSummary && <small>{dateSummary}</small>}
            </div>
        );
    }

    renderPeriodDateSummary() {
        const { t } = this.props;
        if (this.props.periodType === BU_PERIOD_PERIODIC) {
            if (this.props.firstDay === 1) {
                return null;
            }

            return `${t('business_unit_main_info.period_start_day')}: ${this.props.firstDay}`;
        }

        const fromDate = this.state.periodFirstDate ? moment(this.state.periodFirstDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '';
        const toDate = this.state.periodLastDate ? moment(this.state.periodLastDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '';

        if (!fromDate && !toDate) {
            return null;
        }

        return `${fromDate} - ${toDate}`;
    }

    getBudgetReadOnly() {
        if(this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS || this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS)
            return true;

        return false
    }

    getBudgetConfigurationHelpText() {
        const { t } = this.props;
        if(this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS)
            return t('business_unit_main_info.budget_sum_campaigns');

        if(this.props.budgetType === ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS)
            return t('business_unit_main_info.budget_sum_adgroups');

        return ""
    }

    renderBudgetSection() {
        return (
            <BudgetConfiguration
                canEditCurrency={this.props.canEditCurrency}
                budgetCurrency={this.props.budgetCurrency}
                periodType={this.props.periodType}
                periodFirstDate={moment(this.props.periodFirstDate, 'YYYY-MM-DD').toDate()}
                periodLastDate={moment(this.props.periodLastDate, 'YYYY-MM-DD').toDate()}
                allocatedBudget={this.props.allocatedBudget}
                isReadOnly={this.getBudgetReadOnly()}
                lastPeriodBalance={this.props.leftoverBudget}
                rollover={this.props.rollover}
                onRolloverChange={this.handleRolloverChange}
                onBudgetChange={this.handleBudgetChange}
                budgetFootnoteText={this.getBudgetConfigurationHelpText()}
                allowBudgetPartialGoals={true}
                budgetPartialGoals={this.props.budgetPartialGoals}
            />
        )
    }

    handleRolloverChange(value) {
        this.props.onRolloverChange(value)
    }

    handleBudgetChange(newCurrency, newBudget, newBudgetPartialGoals) {
        this.props.onBudgetChange(newCurrency, newBudget, newBudgetPartialGoals)
    }

    handleGoal1Change(data) {
        this.props.onGoalChange(1, data)
    }

    handleScheduleConfigurationChange(itemScheduleConfiguration) {
        this.props.onScheduleConfigurationChange(itemScheduleConfiguration);
    }

    handleGoal2Change(data) {
        this.props.onGoalChange(2, data)
    }

    handleSelectedTemporalRangeDefinition(range, selectedDay) {
        const from = this.state.periodFirstDate ? moment(this.state.periodFirstDate, 'YYYY-MM-DD') : null;
        const to = this.state.periodLastDate ? moment(this.state.periodLastDate, 'YYYY-MM-DD') : null;
        const clickedMoment = moment(selectedDay);

        let newFrom = from;
        let newTo = to;

        if (from && to) {
            newFrom = clickedMoment;
            newTo = null;
        } else if (from && !to) {
            if (clickedMoment.isAfter(from)) {
                newTo = clickedMoment;
            } else {
                newFrom = clickedMoment;
            }
        } else {
            newFrom = clickedMoment;
        }

        this.setState({
            periodFirstDate: newFrom ? newFrom.format('YYYY-MM-DD') : null,
            periodLastDate: newTo ? newTo.format('YYYY-MM-DD') : null
        });

        if (newFrom && newTo) {
            const startOfToday = moment().startOf('day');
            if (newTo.isBefore(startOfToday)) {
                const { t } = this.props;
                alert(t('business_unit_main_info.cannot_select_past_period'));
                this.setState({
                    periodFirstDate: this.props.periodFirstDate,
                    periodLastDate: this.props.periodLastDate,
                    isDatePickerOpen: false
                });
                return;
            }
            
            this.setState({ isDatePickerOpen: false });
            this.props.onPeriodDatesChange(newFrom, newTo);
        }
    }
}

export const BusinessUnitMainInfo = withTranslation()(BusinessUnitMainInfoClass);
export default BusinessUnitMainInfo;
